import { IonButton, IonIcon, IonRouterLink } from '@ionic/react'
import { chevronForwardOutline } from 'ionicons/icons'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { TextStyle } from '../../../components'

type Props = {
  mainTitle: string
  mainHref?: string
  subTitle?: string
  subHref?: string
  buttons?: {
    title: string
    backgroundColor?: string
    link?: string
  }[]
}

export const MainTitle: React.FC<Props> = observer(({ mainTitle, mainHref, buttons, subTitle, subHref }) => {
  return (
    <IonRouterLink href={mainHref} color={'dark'}>
      <MainTitleContainer>
        <LeftItemsContainer>
          <TextStyle type={'b_16'}>{mainTitle}</TextStyle>
          {buttons &&
            buttons.map((d, i) => (
              <IonRouterLink key={i} routerLink={d.link}>
                <CustomButton backgroundColor={d.backgroundColor}>
                  <TextStyle type={'m_13'} color={'white'}>
                    {d.title}
                  </TextStyle>
                </CustomButton>
              </IonRouterLink>
            ))}
        </LeftItemsContainer>
        <IonButton routerLink={subHref} size="small" fill="clear" color="medium">
          <TextStyle type={'b_16'} color={'primary_dark'}>
            {subTitle}
          </TextStyle>
          <IonIcon slot="end" icon={chevronForwardOutline} />
        </IonButton>
      </MainTitleContainer>
    </IonRouterLink>
  )
})

const MainTitleContainer = styled.div`
  padding: 15.5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ion-button {
    padding: 0;
    margin: 0;
    --padding-end: 0;
  }
`

const LeftItemsContainer = styled.div`
  display: flex;
  align-items: center;
`

const CustomButton = styled.div<{ backgroundColor?: string }>`
  margin-left: 10px;
  background-color: ${(prop) => prop.backgroundColor};
  border-radius: 4px;
  padding: 0 10px 2px 10px;
  cursor: pointer;
`
